import { PositionIsLeadershipPositionFragment } from "gql/graphql";
import { useYesOrNo } from "@/shared/typography";
import { Hidable, Value } from "@/shared/value";

/** Руководящая ли должность — «Да» или «Нет», а не голый флаг. */
export function PositionIsLeadershipPosition({
  data,
}: {
  data?: Hidable<PositionIsLeadershipPositionFragment>;
}) {
  const yesOrNo = useYesOrNo();

  return (
    <Value data={data}>
      {(position) => <span>{yesOrNo(position.isLeadershipPosition)}</span>}
    </Value>
  );
}
